import React, { useEffect } from 'react'
import parse from 'html-react-parser'
import TableOfContents from './table-of-contents'
import BackToTopButton from './back-to-top-btn'
import CtaSection from './cta-section'
import { Spinner } from '../Spinner'
import NoJavascript from '../NoJavascript'

export default ({ controller }) => {
  if (!controller.articlePayload || Object.keys(controller.articlePayload).length === 0) {
    return <Spinner size="20" className="fixed top-1/2 left-1/2" />
  }

  return (
    <div>
      <div className="flex flex-row w-full justify-center md:gap-2 bg-paper px-4 md:px-8">
        <div className="relative hidden md:flex md:w-[20%] lg:w-[1%]">
          {<TableOfContents controller={controller} selector="article" />}
        </div>
        <div className="w-full md:w-[80%] lg:w-[99%] flex flex-col items-center">
          {parse(controller.htmlContent)}
        </div>
      </div>
      <BackToTopButton />
      <CtaSection />
      <NoJavascript />
    </div>
  )
}
